import {
    EssentialProductFilter, PriceFilterDto,
    ProductAttributeType,
    ProductSearchFilter,
    SalesConditionType
} from '@eurogast/hub-client-typescript';

export abstract class ProductSearchFilterDeserializer {
    public static parseSearchFilter(productSearchFilter: string): ProductSearchFilter {
        const result: ProductSearchFilter = {};
        const parts = productSearchFilter.split('::');
        result.categoryId = parts[0];
        result.attributes = parts[1] === '[]' ? null : parts[1].replace(/[\][]/g, '')
            .split(';;').map((s) => {
            return ProductAttributeType[s.replace('_', '')];
        });
        result.salesConditions = parts[2] === '[]' ? null : parts[2].replace(/[\][]/g, '')
            .split(';;').map((s) => {
            return SalesConditionType[s.replace('_', '')];
        });
        result.essential = EssentialProductFilter[parts[3].replace('_', '')];
        result.prices = parts[4] === '[]' ? null : parts[4].replace(/[\][]/g, '')
            .split(';;').map((s) => {
            return PriceFilterDto[s.replace('_', '')];
        });
        result.virtualCategories = parts[5] === '[]' ? null : parts[5].replace(/[\][]/g, '').split(';;');


        return result;
    }



}
